var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageWhiteHollow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28716 13.8501C4.82635 14.3273 4.2639 14.6675 3.65603 14.8488C3.89733 14.397 4.05271 13.9009 4.11357 13.3845L4.18557 12.7736L3.67275 12.4338C1.85122 11.227 1.00171 9.53192 1.00171 7.79388C1.00171 4.54375 4.00779 1 9.03221 1C14.4042 1 17.0017 4.24898 17.0017 7.45522C17.0017 10.686 14.372 13.9333 9.03221 13.9333C8.09935 13.9333 7.12446 13.8069 6.26303 13.5782L5.69524 13.4275L5.28716 13.8501Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWhiteHollow);
export default __webpack_public_path__ + "static/media/message_white_hollow.2fbdcb6df40f574dcfb5a9712bfaee2d.svg";
export { ForwardRef as ReactComponent };